import gql from 'graphql-tag';
import publicationFragment from '../fragments/publication';

export default gql`
  query suggestionsListEntries(
    $suggestionsListId: ID!
    $status: [SuggestionStatusCode!]!
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    suggestionsListEntries(
      suggestionsListId: $suggestionsListId
      status: $status
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          source {
            type
            libraryComment
            ... on KeywordSuggestionSource {
              keyword
            }
            ... on SearchSuggestionSource {
              query
            }
            ... on HighDemandSuggestionSource {
              bookings
              maxSimultaneous
            }
            ... on StaffPicksSuggestionSource {
              author
              body
              createdAt
            }
            ... on AwardsSuggestionSource {
              awards
            }
            ... on MissingPopularSuggestionSource {
              loans
              libraries
            }
            ... on MarketSelectionSuggestionSource {
              selectionTitle
              selectionURL
            }
            ... on CollaborativeFilteringSuggestionSource {
              position
              among
            }
          }

          status {
            updatedAt
            count
            code
            licenseId
          }

          publication {
            ...fullPublication
          }
        }
      }
    }
  }
  ${publicationFragment}
`;
